(function () {
      // 固定ヘッダー
      var HEADER_OFFSET = 90;

      // hash を退避してURLから消す
      try {
        if (window.location.hash && window.location.hash.length > 1) {
          sessionStorage.setItem("pendingHash", window.location.hash);
          history.replaceState(null, "", window.location.pathname + window.location.search);
        }
      } catch (e) {}

      // hashへスクロール
      function scrollToPendingHash() {
        var hash = null;
        try { hash = sessionStorage.getItem("pendingHash"); } catch (e) {}
        if (!hash) return;

        try { sessionStorage.removeItem("pendingHash"); } catch (e) {}

        var id = decodeURIComponent(hash.slice(1));
        if (!id) return;

        function go(smooth) {
          var el = document.getElementById(id);
          if (!el) return false;

          var y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
          window.scrollTo({ top: y, behavior: smooth ? "smooth" : "auto" });

          // URLにhashを戻す
          history.replaceState(null, "", window.location.pathname + window.location.search + "#" + encodeURIComponent(id));
          return true;
        }

        // リトライ
        [60, 250, 600, 1000, 1600].forEach(function (t, idx) {
          setTimeout(function () { go(idx >= 3); }, t);
        });
      }

      window.addEventListener("load", scrollToPendingHash);
      document.addEventListener("shopify:section:load", scrollToPendingHash);
    })();